import { gql } from '@apollo/client';

export const GET_REWARD_LIST = gql`
  query GetRewardList {
    rewardList {
      name
      points
      expire
    }
  }
`;
